import { NavLink } from 'react-router-dom';
import './Layout.css';

const links = [
  { to: '/', label: 'home', end: true },
  { to: '/about', label: 'about' },
  { to: '/projects', label: 'projects' },
  { to: '/blog', label: 'blog' },
];

export default function Header() {
  return (
    <header className="nav">
      <div className="container nav-inner">
        <NavLink to="/" className="logo">
          苏日俪格
        </NavLink>
        <ul className="nav-links">
          {links.map(({ to, label, end }) => (
            <li key={to}>
              <NavLink
                to={to}
                end={end}
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </header>
  );
}
